<template>
  <a-form @submit="handleSubmit" :form="form" class="form">
    <a-form-item
      v-show="false"
      label="id"
    >
      <a-input
        v-decorator="['id']"
      />
    </a-form-item>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="开工日期">
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="[
              'workStartDate',
            ]"></a-date-picker>
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="竣工日期">
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="[
              'workEndDate',
            ]"></a-date-picker>
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="养护开始日期">
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="[
              'curingStartDate',
            ]"></a-date-picker>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="养护结束日期">
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            v-decorator="[
              'curingEndDate',
            ]"></a-date-picker>
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="上报结算额（元）">
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['settleAmount', {rules: [{required: false, message: '请输入上报结算额(最多输入两位小数)'}]}]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="最终审计额（元）">
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['auditAmount', {rules: [{required: false, message: '请输入最终审计额(最多输入两位小数)'}]}]" />
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item v-if="showSubmit">
      <a-button htmlType="submit" >Submit</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import pick from 'lodash.pick'
import moment from 'moment'
export default {
  name: 'WorkRemarkForm',
  props: {
    showSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      showable: false,
      addable: false,
      editable: false,
      memberLoading: false
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$notification['error']({
            message: 'Received values of form:',
            description: values
          })
        }
      })
    },
    loadData (data, type) {
      this.visible = true
      if (type && type === 'add') {
        this.showable = false
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.showable = false
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        const record = data
        if (record.workStartDate) {
          record.workStartDate = moment(record.workStartDate, 'YYYY-MM-DD')
        }
        if (record.workEndDate) {
          record.workEndDate = moment(record.workEndDate, 'YYYY-MM-DD')
        }
        if (record.curingStartDate) {
          record.curingStartDate = moment(record.curingStartDate, 'YYYY-MM-DD')
        }
        if (record.curingEndDate) {
          record.curingEndDate = moment(record.curingEndDate, 'YYYY-MM-DD')
        }
        this.confirmLoading = false
        this.$nextTick(() => {
          setFieldsValue(pick(record, [
            'id',
            'workStartDate',
            'workEndDate',
            'curingStartDate',
            'curingEndDate',
            'settleAmount',
            'auditAmount'
          ]))
        })
      } else {
        resetFields()
      }
    }
  }
}
</script>

<style scoped>

</style>
